import styled from 'styled-components';

export const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  position: relative;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
`;

export const MainContent = styled.main`
  flex: 1;
  padding-top: 78px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  max-width: 1700px;
  margin: 0 auto;
  width: 100%;

  @media (max-width: 768px) {
    padding-bottom: 10px; /* Less padding at bottom on mobile */
    min-height: 0; /* Allow it to be smaller than viewport height */
  }
`;
